import { VideoData } from "./VideoPage/VideoData";

export class OpenVideoDialogEvent extends Event {
    data: VideoData;

    constructor(targetData: VideoData) {
        super("openVideoDialog");

        this.data = targetData;
    }

}

declare global {
    interface WindowEventMap {
        openVideoDialog: OpenVideoDialogEvent;
    }
}